module.exports = __webpack_public_path__ + "img/logo_latest.fa26dd14.svg";